import { Component, ErrorInfo, ReactNode } from 'react'

import { captureException } from 'api/sentry'

interface Props {
  fallback?: ReactNode
  children?: ReactNode
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught React Boundary error:', error, errorInfo)
    captureException('React Boundary Error', {
      extra: {
        error: error,
        errorInfo: errorInfo,
      },
    })
  }

  public render() {
    if (this.state.hasError) {
      return this.props.fallback || <></>
    }

    return this.props.children || <></>
  }
}

export default ErrorBoundary
